var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Error_icon",
    "data-name": "Error icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 34,
    height: 34,
    rx: 12,
    transform: "translate(34 34) rotate(180)",
    fill: "#fd1a64"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(7.813 7.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M1.821,22.06A1.821,1.821,0,0,1,0,20.238V1.821a1.821,1.821,0,0,1,3.643,0V20.238A1.821,1.821,0,0,1,1.821,22.06Z",
    transform: "translate(15.599) rotate(45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37-2",
    "data-name": "Line 37",
    d: "M1.821,0A1.821,1.821,0,0,0,0,1.821V20.238a1.821,1.821,0,0,0,3.643,0V1.821A1.821,1.821,0,0,0,1.821,0Z",
    transform: "translate(18.174 15.599) rotate(135)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.2015e754.svg";
export { ForwardRef as ReactComponent };